
export default {
  download: 'Downloaden',
}
